import { render, staticRenderFns } from "./ResultConclusion.vue?vue&type=template&id=7efbebc0&"
import script from "./ResultConclusion.vue?vue&type=script&lang=js&"
export * from "./ResultConclusion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports